// extracted by mini-css-extract-plugin
export var link = "_qr-0";